"use strict";

exports.__esModule = true;
exports.TicketCommentActionButtons = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CommentIconsHeader = _styledComponents["default"].div.withConfig({
  displayName: "TicketCommentActionButtons__CommentIconsHeader",
  componentId: "sc-qv9xbf-0"
})(["grid-area:topright;margin-top:-10px;display:flex;justify-content:flex-end;"]);
var TicketCommentActionButtons = exports.TicketCommentActionButtons = function TicketCommentActionButtons(props) {
  var ticketComment = props.ticketComment;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _ticketComment$delete = ticketComment.deletePermission,
    deletePermission = _ticketComment$delete === void 0 ? true : _ticketComment$delete,
    _ticketComment$editPe = ticketComment.editPermission,
    editPermission = _ticketComment$editPe === void 0 ? true : _ticketComment$editPe;
  return /*#__PURE__*/_react["default"].createElement(CommentIconsHeader, {
    style: {
      paddingTop: "3px"
    }
  }, editPermission && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "CommentEditIcon",
    minimal: true,
    disabled: ticketComment.disabled,
    icon: /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      style: {
        width: "16px"
      },
      icon: "edit",
      size: _core.IconSize.LARGE
    }),
    onClick: ticketComment.handleCommentEditClick
  }), deletePermission && /*#__PURE__*/_react["default"].createElement(_Core.ActionButton, {
    "data-testid": "CommentDeleteIcon",
    icon: _icons.IconNames.TRASH,
    minimal: true,
    disabled: ticketComment.disabled,
    onClick: ticketComment.handleCommentDeleteClick,
    confirm: translate("Ticketing.DeleteCommentButton.Confirm", "Are you sure you want to delete this comment? This action cannot be undone.")
  }));
};